import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';

import { WardrobesConfigsContext } from '../../contexts/WardrobesConfigsContext';
import { ActiveWardrobeContext } from '../../contexts/ActiveWardrobeContext';
import ProgressBarItem from './ProgressBarItem';
import PopUp from '../popup/PopUp';
import CloseConfiguratorPopup from '../popup/CloseConfiguratorPopup';

const ProgressBar = props => {
  const { activeLvl, ownProgressive, hideInactive } = props;
  const { wardrobesConfigs, setWardrobesConfigs } = useContext(WardrobesConfigsContext);
  const history = useHistory();
  const path = history.location.pathname;

  const linkTo = link => {
    history.push(link);
  };

  const progressLevels = [
    {
      name: 'Korpus',
      link: path.includes('/wardrobe-type') ? '/wardrobe-type' : '/wardrobe-body-configuration',
      func: path.includes('/wardrobe-type') ? null : () => linkTo('/wardrobe-body-configuration'),
    },
    { name: 'Drzwi', link: '/wardrobe-fronts-configuration' },
    { name: 'Akcesoria', link: '/accessories-configuration' },
  ];

  const { activeWardrobe, setActiveWardrobe } = useContext(ActiveWardrobeContext);

  const summaryCopy = reactLocalStorage.getObject('summaryCopy');
  const copyWardrobe = reactLocalStorage.getObject('copyWardrobe');

  const openPopup = () => {
    const popup = document.querySelector(`[data-popup-name="close-configurator"]`);
    if (!!popup) {
      popup.classList.add('open');
    }
  };

  const backSummary = () => {
    if (summaryCopy.length !== undefined) {
      setActiveWardrobe(0);
      setWardrobesConfigs([...summaryCopy]);
    }
    if (copyWardrobe.length !== undefined) {
      setActiveWardrobe(0);
      setWardrobesConfigs([...copyWardrobe]);
    }
    localStorage.removeItem('copyWardrobe');
    localStorage.removeItem('summaryCopy');
    history.push('/summary');
  };

  return (
    <>
      <div className="container progress-bar">
        {path === '/buy-accessories' || path === '/buy-wardrobe-body' ? (
          <button onClick={path === '/summary' ? openPopup : () => history.push('/')}>
            <span className="icon-left-arrow" />
            <span className="go-back-text">Wstecz</span>
          </button>
        ) : path === '/wardrobe-body-configuration' ? (
          copyWardrobe.length || summaryCopy.length ? (
            <button onClick={backSummary}>
              <span className="icon-left-arrow" />
              <span className="go-back-text">Wstecz</span>
            </button>
          ) : (
            <button onClick={() => history.goBack(-1)}>
              <span className="icon-left-arrow" />
              <span className="go-back-text">Wstecz</span>
            </button>
          )
        ) : (
          <button onClick={() => history.goBack(-1)}>
            <span className="icon-left-arrow" />
            <span className="go-back-text">Wstecz</span>
          </button>
        )}
        {!hideInactive && (
          <div className="progress-bar__box progress-bar__box--flex">
            {activeLvl === undefined ? (
              <div className="flex-center">
                <img
                  className="flex-logo"
                  src={`${process.env.PUBLIC_URL}/img/svg-illustrations/flex.svg`}
                  alt=""
                />
              </div>
            ) : ownProgressive === undefined ? (
              progressLevels.map((item, key) => (
                <ProgressBarItem
                  name={item.name}
                  func={item.func}
                  link={item.link}
                  key={`configuration-step-${key}`}
                  active={key <= activeLvl}
                  activeWardrobe={activeWardrobe}
                  wardrobesConfigs={wardrobesConfigs}
                />
              ))
            ) : (
              ownProgressive.map((item, key) => (
                <ProgressBarItem
                  name={item.name}
                  func={item.func}
                  link={item.link}
                  key={`configuration-step-${key}`}
                  active={key === activeLvl}
                  ownProgressive
                  activeWardrobe={activeWardrobe}
                  wardrobesConfigs={wardrobesConfigs}
                />
              ))
            )}
          </div>
        )}
        <button className="logo-text" onClick={openPopup}>
          <p>Zamknij konfigurator</p> <span className="icon-plus" />
        </button>
      </div>

      <PopUp title="Czy chcesz kontynuować?" popupName="close-configurator">
        <CloseConfiguratorPopup />
      </PopUp>
    </>
  );
};

ProgressBar.propTypes = {
  activeLvl: PropTypes.number,
  link: PropTypes.string,
  ownProgressive: PropTypes.arrayOf(PropTypes.object),
};

export default ProgressBar;
